import type { ChatUIMessage } from "@/types/chat";

/** Copy completed exchanges before the failed request, without replaying tool history. */
export function getRecoveryForkMessages(messages: ChatUIMessage[]): ChatUIMessage[] {
  const failedTurn = messages.findLastIndex((message) => message.role === "user");
  const lastSuccess = messages.slice(0, failedTurn).findLastIndex((message) =>
    message.role === "assistant" && !message.metadata?.interrupted &&
    message.parts.some((part) => part.type === "text" && part.text.trim().length > 0),
  );
  return messages.slice(0, lastSuccess + 1).flatMap((message) => {
    const parts = message.parts.filter((part) => part.type === "text" && part.text.trim().length > 0);
    return parts.length ? [{ id: message.id, role: message.role, parts }] : [];
  });
}
